var _path, _path2, _path3, _path4;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconMenuItemCaseInquiry(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 1a9 9 0 100 18 9 9 0 000-18v0z",
    stroke: "#ED1B2E",
    strokeWidth: 1.6,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.302 8.2s.04-.938.94-1.69c.535-.445 1.178-.575 1.753-.583.525-.006.995.084 1.276.223.48.238 1.416.817 1.416 2.05 0 1.297-.818 1.885-1.748 2.533-.93.648-1.169 1.284-1.169 2.012",
    stroke: "#ED1B2E",
    strokeWidth: 1.6,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.882 14.865a.117.117 0 11-.233 0 .117.117 0 01.233 0z",
    fill: "#ED1B2E",
    stroke: "#ED1B2E",
    strokeWidth: 1.6
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.715 16.715L23 23",
    stroke: "#ED1B2E",
    strokeWidth: 1.6,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })));
}

export default SvgIconMenuItemCaseInquiry;